var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportLimit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.994 12.35A9.956 9.956 0 0118.5 19.6 9.96 9.96 0 0112 22C6.477 22 2 17.523 2 12a9.97 9.97 0 013.5-7.6 9.958 9.958 0 016.15-2.394 7.472 7.472 0 00-.748 1.564 8.463 8.463 0 00-4.335 1.892 9.957 9.957 0 012.405 5.788h2.278V9.273a7.531 7.531 0 003.477 3.477H12.75v7.717a8.462 8.462 0 004.683-1.93 9.957 9.957 0 01-2.394-5.644 7.45 7.45 0 001.57.478 8.46 8.46 0 001.89 4.107 8.464 8.464 0 001.93-4.38 7.472 7.472 0 001.565-.749zM11.25 20.466V12.75H8.972a9.958 9.958 0 01-2.405 5.788 8.462 8.462 0 004.683 1.93zm-5.75-2.99a8.457 8.457 0 001.968-4.727H3.533a8.778 8.778 0 00.019.191A8.463 8.463 0 005.5 17.478zm1.968-6.227A8.457 8.457 0 005.5 6.522a8.463 8.463 0 00-1.967 4.728h3.935z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 6a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM24 6a6 6 0 11-12 0 6 6 0 0112 0zm-6.457 1.085h.954l.135-4.01h-1.225l.136 4.01zm.942.8a.637.637 0 00-.465-.171.637.637 0 00-.466.174.58.58 0 00-.174.434c0 .175.058.32.174.433.12.114.275.171.466.171a.637.637 0 00.465-.171.573.573 0 00.178-.433.578.578 0 00-.178-.438z",
    fill: "currentColor"
  })));
}
SvgSportLimit.displayName = 'SportLimit';
export default SvgSportLimit;